import {Stack} from '@mui/material';
import {Grid} from '@mui/material';
import {AppControlledInput} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';

interface RenderPhoneInputProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderPhoneInput: React.FC<RenderPhoneInputProps> = ({field, control, baseFieldName, gridSize}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledInput
                    label={field.title}
                    fullWidth
                    placeholder={field.placeHolder}
                    type="tel"
                    name={`${baseFieldName}.value`}
                    required={field.isRequired}
                    control={control}
                />
            </Stack>
        </Grid>
    );
};

export default RenderPhoneInput;
